<template>
  <div class="flex items-center gap-2" :role="role" :aria-label="ariaLabel">
    <slot />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    role?: 'group' | 'toolbar'
    ariaLabel?: string | undefined
  }>(),
  {
    role: 'group',
    ariaLabel: undefined,
  },
)
</script>
